// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"147e5a4c","460":"147e5a4c","604":"147e5a4c","640":"147e5a4c","676":"147e5a4c","912":"147e5a4c"}[chunkId] + ".chunk.css";
};